






import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import IntegrationService from "../services/integration.service";

@Component
export default class IntegrationCallback extends Mixins(BaseServiceMixin) {
  private integrationService!: IntegrationService;

  public async created() {
    this.integrationService = new IntegrationService(this.axiosInstance);
  }

  private async mounted() {
    const params = this.$route.query;
    const state = (params.state as string) || undefined;
    const code = (params.code as string) || undefined;
    try {
      if (state && code) {
        const integrationKey = await this.integrationService.activateIntegration(state, code);
        this.vuexStore.setCompanyAPIKey(integrationKey);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("error : ", error);
      //error
    } finally {
      this.goTo("integrations");
    }
  }

  private goTo(path: string) {
    if (this.$router.currentRoute.name !== path) {
      this.$router.push(path).catch(() => {
        // Handle error
      });
    }
  }
}
